<template>
  <div class="prompt-weight">
    <div class="d-flex justify-content-between">
      <div class="font-weight-bold">{{ 'Prompt Weight' | trans }}</div>
      <span class="badge badge-starter" @click="handleProOrChange">{{ 'STARTER' | trans }}</span>
    </div>
    <span class="text-white">
      {{ 'Adjust the prompt weight to fine-tune how much your input impacts the resulting image. Increase the prompt weight for a stronger influence.' | trans }}
    </span>
    <div class="slider">
      <input
          type="range"
          class="form-control-range range-slider"
          id="formControlRange"
          min="0"
          max="20"
          v-model.number="activeStage.settings.cfg_scale"
          @change="handleProOrChange"
          :class="{ 'disabled': isFreeUser }"
      >
      <div class="slider-points">
        <p>0%</p>
        <p>50%</p>
        <p>100%</p>
      </div>
    </div>
  </div>
</template>
<script>
import store from './../../mixins/store.mixin';
import user from './../../mixins/user.mixin';
import currentJob from './../../mixins/current_job.mixin';
import { EventBus } from '../../events/event.bus';
import { EVENT_PAYMENT_UNLOCK_STARTER } from "../../events/payment.events";

export default {
  name: "PromptWeight",
  props: {},
  components: {},
  mixins: [
    store,
    currentJob,
    user
  ],
  data() {
    return {};
  },
  mounted: function () {
  },
  created: function () {
  },
  methods: {
    handleProOrChange() {
      if (this.isFreeUser) {
        EventBus.$emit(EVENT_PAYMENT_UNLOCK_STARTER, {});
        this.activeStage.settings.cfg_scale = 7;
      } else {

      }
    },
  },
  computed: {}
};
</script>
<style lang="scss">
.prompt-weight {
  gap: 20px;
  display: flex;
  flex-direction: column;
}
.slider {
  display: flex;
  padding-top: 10px;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 10px;
  align-self: stretch;

  .slider-points {
    display: flex;
    height: 19px;
    justify-content: space-between;
    align-items: flex-start;
    flex-shrink: 0;
    align-self: stretch;
  }
}

.badge-pro {
  background: #1B5E20;
}

.range-slider {
  -webkit-appearance: none;
  appearance: none;
  width: 100%;
  height: 12px;
  border-radius: 13px;
  background: #383838;
  cursor: pointer;

  &::-webkit-slider-thumb {
    -webkit-appearance: none;
    appearance: none;
    width: 21px;
    height: 21px;
    background: #1266F1;
    border-radius: 50%;
    border: 1px solid #fff;

  }
  &::-moz-range-thumb {
    width: 21px;
    height: 21px;
    background: #1266F1;
  }
  .disabled {
    opacity: .5;
    cursor: not-allowed;
  }
}
</style>
